import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import { Heading, AccentBar, MaxWidthWrapper, RedButton, BlackButton } from '../styles'
import border from 'assets/greyborder.png'
import { useRouteContext } from 'contexts/RouteContext'

const StyledHeading = styled(Heading)`
  text-align: left;
`

const StyledAccentBar = styled(AccentBar)`
  margin: 0 0 ${rem(19)} 0;
`

const SubHeading = styled.p`
  font-size: ${rem(20)};
  line-height: 32px;
  color: #333;
  max-width: 830px;
  margin: 0 auto;
  margin-bottom: 2rem;
`

const BackgroundWrapper = styled.div`
  background: #fff;
`

const BorderImage = styled.div`
  background: url(${border});
  height: 25px;
  width: 100%;
  background-position: center;
`
export const ButtonContainer = styled.div`
  margin-bottom: ${rem(46)};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  button,
  a {
    min-width: 272px;
    box-sizing: border-box;
  }

  @media (max-width: 644px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

const PinkButton = styled(RedButton)`
  background: transparent;
  color: ${({ theme }) => theme.pink};
  border: 2px solid ${({ theme }) => theme.pink};
  margin-right: ${rem(24)};
  box-sizing: border-box;
  text-align: center;

  @media (max-width: 644px) {
    margin-right: 0;
    margin-bottom: 1rem;
  }
`

const SolidPinkButton = styled(PinkButton)`
  background: ${({ theme }) => theme.pink};
  color: #fff;
`

const FAQ = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem(64 - 16)};
`

const FAQLink = styled.a`
  color: ${({ theme }) => theme.pink};
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 1px;
  text-decoration-line: underline;
`

const Wrapper = styled.div`
  display: flex;
  justify: content: space-between;

  && div:nth-child(1) {
    margin-right: ${rem(33)}

  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints[0]}) {
    flex-direction: column;
    && div:nth-child(1) {
      margin-right: 0;
    }
  }
`

export const StartFundraising = (): JSX.Element => {
  const { fundraisingEvent } = useRouteContext()
  return (
    <>
      <BackgroundWrapper>
        <BorderImage />
        <MaxWidthWrapper>
          <StyledHeading>
            Jingle Jam - the world's biggest games charity event - is back!
          </StyledHeading>
          <StyledAccentBar />
          <Wrapper>
            <div>
              <SubHeading>
                Jingle Jam brings together the whole gaming community in an epic and emotional event
                that runs from 1 - 14 December.
              </SubHeading>
              <SubHeading>
                And this year, you too can host your very own Jingle Jam fundraiser!
              </SubHeading>
              <SubHeading>
                Start fundraising and add the Jingle Jam 2022 Games Collection reward when you set
                up your fundraising page. When your supporters donate at least £35 to your page and
                select the reward, they will receive their Games Collection.
              </SubHeading>
            </div>
            <div>
              <SubHeading>
                This year's collection is the biggest and most valuable ever - containing over 85
                full games with a combined value over £1,000 (about $1,200).
              </SubHeading>
              <SubHeading>
                Jingle Jam brings together the whole gaming community in an epic and emotional event
                that runs from 1-14 December.
              </SubHeading>
            </div>
          </Wrapper>
          <ButtonContainer>
            {fundraisingEvent?.supportable && (
              <BlackButton
                as='a'
                href='https://tiltify.com/jingle-jam/jingle-jam-2022/start'
                style={{ margin: 0, display: 'flex', justifyContent: 'center' }}
              >
                START FUNDRAISING
              </BlackButton>
            )}
            <PinkButton
              as='a'
              href='https://www.jinglejam.co.uk/toolkit'
              target='blank'
              rel='noopener noreferrer'
              style={{ margin: 0 }}
            >
              DOWNLOAD THE TOOLKIT
            </PinkButton>
            <SolidPinkButton
              as='a'
              href='https://discord.gg/dsCsJJcvAx'
              target='blank'
              rel='noopener noreferrer'
              style={{ margin: 0 }}
            >
              JOIN THE DISCORD SERVER
            </SolidPinkButton>
          </ButtonContainer>
          <FAQ>
            <FAQLink
              href='https://info.tiltify.com/support/solutions/articles/43000646877-jingle-jam-faqs'
              target='_blank'
              rel='noopener noreferrer'
            >
              JINGLE JAM FAQ
            </FAQLink>
          </FAQ>
        </MaxWidthWrapper>
        <BorderImage />
      </BackgroundWrapper>
    </>
  )
}
